var _rect, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTwitterNotConnected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8189 25.25C20.4514 25.25 25.1722 18.0852 25.1722 11.8721C25.1722 11.6686 25.1681 11.466 25.159 11.2643C26.0774 10.5985 26.8702 9.774 27.5 8.82956C26.6591 9.20408 25.7542 9.45616 24.8049 9.56982C25.7738 8.98767 26.5177 8.06692 26.8686 6.96922C25.9473 7.51678 24.9395 7.90276 23.8885 8.11052C23.0321 7.19662 21.8129 6.625 20.4627 6.625C17.871 6.625 15.7693 8.73067 15.7693 11.3262C15.7693 11.6952 15.8105 12.0541 15.891 12.3983C11.9904 12.2017 8.53166 10.3307 6.21686 7.48577C5.79995 8.20326 5.58065 9.01877 5.58136 9.84898C5.58136 11.4802 6.40992 12.9203 7.66987 13.7628C6.9246 13.74 6.19568 13.5383 5.54436 13.1747C5.54367 13.1945 5.54367 13.2137 5.54367 13.2348C5.54367 15.5118 7.1614 17.413 9.30886 17.8438C8.90553 17.9539 8.48935 18.0096 8.07133 18.0093C7.77529 18.0091 7.47994 17.9807 7.18927 17.9245C7.78677 19.7927 9.51934 21.1522 11.5735 21.1902C9.96716 22.4515 7.94367 23.2028 5.74448 23.2028C5.36612 23.2028 4.99238 23.1812 4.625 23.1377C6.70207 24.4715 9.16839 25.2498 11.8192 25.2498",
    fill: "#1DA1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 6,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C22.2385 30 20 27.7615 20 25C20 22.2385 22.2385 20 25 20C27.7615 20 30 22.2385 30 25C30 27.7615 27.7615 30 25 30ZM25 24.293L23.586 22.8785L22.8785 23.586L24.293 25L22.8785 26.414L23.586 27.1215L25 25.707L26.414 27.1215L27.1215 26.414L25.707 25L27.1215 23.586L26.414 22.8785L25 24.293Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitterNotConnected);
export default __webpack_public_path__ + "static/media/logo_twitter_not_connected.826824a4818c34a77fb273e201c5dd3c.svg";
export { ForwardRef as ReactComponent };